import { Component, OnInit } from '@angular/core';
import { EmailSettingGroupComponent as AbpEmailSettingGroupComponent } from '@abp/ng.setting-management/config';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { ToasterService } from '@abp/ng.theme.shared';

@Component({
    selector: 'ca-email-setting-group',
    templateUrl: './email-setting-group.component.html',
    styleUrl: './email-setting-group.component.scss',
    standalone: false
})
export class EmailSettingGroupComponent implements OnInit {
  activeTab: string | number = 1;
  reportEmailSettingsForm: FormGroup;
  abpEmailSettingGroup = AbpEmailSettingGroupComponent;

  private readonly prefix = 'ReportingEmail';
  private readonly displayName = `${this.prefix}.DisplayName`;
  private readonly address = `${this.prefix}.Address`;
  private readonly username = `${this.prefix}.Username`;
  private readonly password = `${this.prefix}.Password`;

  constructor(
    private fb: FormBuilder,
    private config: ConfigStateService,
    private localizationService: LocalizationService,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService
  ) {
    this.reportEmailSettingsForm = this.fb.group({
      displayName: [
        this.config.getSetting(this.displayName),
        {
          validators: [Validators.required],
        },
      ],
      address: [
        this.config.getSetting(this.address),
        {
          validators: [Validators.required],
        },
      ],
      username: [
        this.config.getSetting(this.username),
        {
          validators: [],
        },
      ],
      password: [
        null,
        {
          validators: [],
        },
      ],
    });
  }

  ngOnInit(): void {}

  onSubmitReportEmailSettings(): void {
    if (!this.reportEmailSettingsForm.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.displayName,
      settingValue: this.reportEmailSettingsForm.get('displayName').value,
    });

    settings.push({
      settingName: this.address,
      settingValue: this.reportEmailSettingsForm.get('address').value,
    });

    settings.push({
      settingName: this.username,
      settingValue: this.reportEmailSettingsForm.get('username').value,
    });

    settings.push({
      settingName: this.password,
      settingValue: this.reportEmailSettingsForm.get('password').value,
    });

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
